module.exports = __webpack_public_path__ + "img/wa.022040df.svg";